"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _publish = _interopRequireDefault(require("../../../../components/tracker/publish"));

var _Analytics = _interopRequireDefault(require("@insided/deprecated-preact-components/analytics/Analytics"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _QuickLinksContainer = require("./QuickLinksContainer.sync");

var _widgetContainer = require("@insided/deprecated-preact-components/widget-container");

/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
var trackerHandler = function trackerHandler(title, url, idx, quicklinkDestination, quicklinkType) {
  if (typeof window === 'undefined') return;
  var eventLabel = {
    Title: title,
    Position: idx + 1,
    Link: url
  };

  _Analytics.default.send('Homepage', 'Quick link clicked', eventLabel);

  _publish.default.trackEvent('userevent', {
    type: 'Quick Link Clicked',
    quick_link_title: title,
    quick_link_url: url,
    quick_link_position: idx + 1,
    quick_link_destination: quicklinkDestination,
    quick_link_type: quicklinkType,
    user: (0, _insidedDataStorage.getInsidedData)('user')
  });
};

var QuickLink = function QuickLink(props) {
  var _window$location;

  var item = props.item,
      isVisibleDesktop = props.isVisibleDesktop,
      selectedCardsPerRow = props.selectedCardsPerRow,
      idx = props.idx,
      hasWidgetTitle = props.hasWidgetTitle,
      hasWidgetSubtitle = props.hasWidgetSubtitle;
  var iconSrc = item.iconSrc,
      imageSrc = item.imageSrc,
      title = item.title,
      url = item.url,
      openNewTab = item.openNewTab,
      description = item.description,
      imageDescription = item.imageDescription;
  var quicklinkHeroClassName = iconSrc ? 'padding__icon quicklink__hero' : 'quicklink__hero';
  var quicklinkDestination = typeof window !== 'undefined' && url.includes((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) ? 'internal' : 'external';
  var urlTarget = openNewTab ? '_blank' : '';
  var quicklinkBoxClassName = !isVisibleDesktop ? ' is-hidden-mobile-up' : '';
  var hasImageOrIcon = iconSrc || imageSrc;
  var quicklinkType = '';

  if (imageSrc) {
    quicklinkType = 'image';
  } else if (iconSrc) {
    quicklinkType = 'icon';
  } else {
    quicklinkType = 'text';
  }

  var QuickLinkTag = (0, _widgetContainer.genericWidgetHeaderTagCalculator)(hasWidgetTitle, hasWidgetSubtitle);
  return (0, _preact.h)("article", {
    className: "featured-topic quicklink__box".concat(quicklinkBoxClassName, " card-widget-wrapper quicklink-").concat(quicklinkType),
    style: "--cards-per-row: ".concat(selectedCardsPerRow !== null && selectedCardsPerRow !== void 0 ? selectedCardsPerRow : _QuickLinksContainer.DEFAULT_CARDS_PER_ROW)
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    onClick: function onClick() {
      return trackerHandler(title, url, idx, quicklinkDestination, quicklinkType);
    },
    className: "quicklink__url",
    tabIndex: 0,
    target: urlTarget
  }, hasImageOrIcon ? (0, _preact.h)("figure", {
    className: iconSrc ? 'figure-padding__icon' : ''
  }, (0, _preact.h)(_LazyImage.default, {
    type: "background",
    src: (0, _absoluteUrlRuntime.resolveUrl)(iconSrc || imageSrc || ''),
    className: quicklinkHeroClassName,
    alt: imageDescription
  })) : null, (0, _preact.h)("div", {
    className: "quicklink__title"
  }, (0, _preact.h)("header", null, (0, _preact.h)(QuickLinkTag, {
    className: "h3 card-widget-title"
  }, title)), (0, _preact.h)("p", {
    className: "text--meta card-widget-text"
  }, description))));
};

var _default = QuickLink;
exports.default = _default;